<template>
  <div class="container">
    <ul class="explore-list">
      <li class="ex-welfare">
        <router-link class="exWelfare" :to="{ path: '/birthday_board' }">
          <i class="icon-c icon-q"></i>生日贴士
          <p><span v-if="tips>0">近期有{{tips}}个人过生日<b class="hotPoint"></b></span></p>
        </router-link>
       </li>
      <li class="ex-welfare">
        <router-link class="exWelfare" :to="{ path: '/activity' }">
          <i class="icon-c icon-s"></i>趣味活动
        </router-link>
      </li>
      <li class="ex-welfare" v-if="!isWxwork">
        <a :href="preUrl" class="exWelfare">
          <i class="icon-c icon-w"></i>微信送礼
        </a>
      </li>
    </ul>
  
      <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
      <home :ishome=0></home>
  </div>
</template>
<script>
import url from '../../../../config/config.js'
import aghm from '../../api/aghm.js'
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
import home from '../common/home.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
  data () {
    return {
        preUrl:'',
     	  tips:'',
        tipDialog:false,
        tipText:'',
    }
  },
  components:{
    XDialog,
    home
  },
  computed:{
  	 ...mapGetters({
      isShowMergeNav:'getisShowMergeNav',
      isWxwork:'getisWxAgent'
     }),
  },
  watch:{

  },
  created(){
    this.preUrl = url.magh_domin+'/gift/card/list?bm=0';
    aghm.getBirthdayLately().then((res) =>{
      if(res.data.errno){
          alert(res.data.error)
      }else{
          let data = res.data.body;
          this.tips = data.birthdayTotal
      }
    },(error) =>{
      this.showMsg(error)
    })
  },
  methods:{
    showMsg(txt){
        this.tipText=txt;
        this.tipDialog=true;
      }
  },
  mounted(){}
}
</script>